import { format } from 'date-fns';

export const formatDateValue = (
  value?: string | Date | null,
  pattern = 'dd/MM/yyyy HH:mm'
): string => {
  if (!value) return '-';
  return format(new Date(value), pattern);
};
